import * as _ from "lodash"
import * as ACTIONS from "./types"
import { plans } from "models/plans"
import { benefits } from "models/benefits"
import { log_action } from "./misc-actions"
import { replacePlansWithSpeedTiers } from "services/speedTier/speedTier.service"
import {
  replaceDynamicPrices,
  replaceArrayPrices,
  replaceDataArrays
} from "services/dynamicPricing/dynamicPricing.service"
import { getRandom } from "services/cachedRandom/random.service"

// actions for loading the plans

// Load the plans for a given condition
// This is the main action creator to use!
export const loadPlansForCondition = (
  storeName,
  conditionID,
  { currentSpeed, currentPrice = 100 }
) => dispatch => {
  // First flag that we're beginning to fetch data
  try {
    dispatch(plan_fetch_begin())

    dispatch(
      log_action(`StoreName: ${storeName} - ConditionID: ${conditionID}`)
    )

    let data = plans[storeName]

    // We want the data associated with this condition
    let conditionData = data.conditions.find(
      condition => condition.conditionData.id === conditionID
    ).data

    const { options } = conditionData

    // Pick values from the priceArrays if needed
    conditionData.plans = replaceArrayPrices(conditionData.plans, options)

    // Replace the data with offset speed tiers if needed
    conditionData = replacePlansWithSpeedTiers(currentSpeed, conditionData)

    conditionData.plans = replaceDataArrays(conditionData.plans)

    // HACK: rejigs the planOrder
    const newPlanOrder = conditionData.plans.map(plan => plan.id)
    conditionData.planOrderByDevice.BT_ROUTER = newPlanOrder

    // HACK: Replace dynamic prices as needed
    conditionData.plans = replaceDynamicPrices(
      currentPrice,
      conditionData.plans
    )

    // HACK: Check to see if instant on should be set
    const showInstantOn = getRandom("display-instant-on", [false, true])

    if (!showInstantOn) {
      // We need to delete the Instant on benefits from each plan
      conditionData.plans = conditionData.plans.map(plan => {
        const newPlan = _.cloneDeep(plan)
        newPlan.benefits = plan.benefits.filter(
          benefitID => benefitID !== "BT_INSTANT_ON_PLACEHOLDER"
        )
        return newPlan
      })
    }

    // Convert the plan data into an ID normalized form
    let plansByID = conditionData.plans.reduce((aggPlanData, planData) => {
      const { id, ...restOfPlanData } = planData

      return {
        ...aggPlanData,
        [id]: restOfPlanData
      }
    }, {})

    const {
      defaultPlanByDevice,
      planOrderByDevice,
      buildAPlanByStores
    } = conditionData

    // Package it up for the redux store
    const plansData = {
      options,
      defaultPlanByDevice,
      planOrderByDevice,
      plansByID,
      buildAPlanByStores
    }

    dispatch(plan_fetch_success(plansData))
  } catch (err) {
    dispatch(plan_fetch_failed(err))
  }
}

// Load the plans for an array of conditions
// This is used when displaying the selected conditions on a separate page

export const loadPlansForPickedConditions = (
  conditionIDs,
  storeName,
  { currentSpeed, currentPrice = 100 }
) => dispatch => {
  // First flag that we're beginning to fetch data
  try {
    dispatch(picked_plan_fetch_begin())
    let data = plans[storeName]
    const conditionData = {}
    const plansData = {}

    conditionIDs.forEach(conditionID => {
      // We want the data associated with this condition
      conditionData[conditionID] = data.conditions.find(
        condition => condition.conditionData.id === conditionID
      ).data

      // Replace the condition data with speed tiers if relevant
      conditionData[conditionID] = replacePlansWithSpeedTiers(
        currentSpeed,
        conditionData[conditionID]
      )

      conditionData[conditionID].plans = replaceDynamicPrices(
        currentPrice,
        conditionData[conditionID].plans
      )

      // Convert the plan data into an ID normalized form
      let plansByID = conditionData[conditionID].plans.reduce(
        (aggPlanData, planData) => {
          const { id, ...restOfPlanData } = planData

          return {
            ...aggPlanData,
            [id]: restOfPlanData
          }
        },
        {}
      )

      const { options, defaultPlanByDevice, planOrderByDevice } = conditionData[
        conditionID
      ]

      // Package it up for the redux store
      plansData[conditionID] = {
        options,
        defaultPlanByDevice,
        planOrderByDevice,
        plansByID
      }
    })

    dispatch(picked_plan_fetch_success(plansData))
  } catch (err) {
    dispatch(picked_plan_fetch_failed(err))
  }
}

const plan_fetch_begin = () => ({
  type: ACTIONS.FETCH_PLANS_BEGIN
})

const plan_fetch_success = data => ({
  type: ACTIONS.FETCH_PLANS_SUCCESS,
  payload: data
})

const plan_fetch_failed = err => ({
  type: ACTIONS.FETCH_PLANS_FAILURE,
  payload: err
})

const picked_plan_fetch_begin = () => ({
  type: ACTIONS.FETCH_PICKED_PLANS_BEGIN
})

const picked_plan_fetch_success = data => ({
  type: ACTIONS.FETCH_PICKED_PLANS_SUCCESS,
  payload: data
})

const picked_plan_fetch_failed = err => ({
  type: ACTIONS.FETCH_PICKED_PLANS_FAILURE,
  payload: err
})

// actions for loading the benefits
export const loadBenefits = dispatch => {
  try {
    dispatch(benefits_fetch_begin())
    dispatch(benefits_fetch_success(benefits))
  } catch (err) {
    dispatch(benefits_fetch_failed(err))
  }
  // fetch("./images/model/benefits.json")
  //   .then(handleErrors)
  //   .then(data => data.json())
  //   .then(data => benefits)
  //   .then(data => {
  //     dispatch(benefits_fetch_success(data))
  //   })
  //   .catch(err => dispatch(benefits_fetch_failed(err)))
}

const benefits_fetch_begin = () => ({
  type: ACTIONS.FETCH_BENEFITS_BEGIN
})

const benefits_fetch_success = data => ({
  type: ACTIONS.FETCH_BENEFITS_SUCCESS,
  payload: data
})

const benefits_fetch_failed = err => ({
  type: ACTIONS.FETCH_BENEFITS_FAILURE,
  payload: err
})
